module.exports = __webpack_public_path__ + "static/img/2_1_6.d6068b29.jpg";